import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../../_constant/constants';
import { CustomerChangePasswordDto } from '../../_dto/_customer/CustomerChangePasswordDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiChangePassword = async (customerChangePasswordDto: CustomerChangePasswordDto) => {
  const params: IApiParams = {
    url: '/customer/changePassword.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME), 
    },
  };
  return getApi(params, 'PUT', customerChangePasswordDto);
};